import { useQuery } from '@tanstack/vue-query';
import { DotCMSService } from '@/services';
import type { DotCMSPageContent } from '@/types/global';
import { useConfigStore } from '@/stores/modules/configStore';
//import { DOTCMS_CONTENT_ID } from '@/constants/content';

export function useDotCMSContent(contentIds: string[], queryKey: string) {
  return useQuery({
    queryKey: ['dotcms-content', queryKey],
    queryFn: async () => {
      const results: DotCMSPageContent[] = [];
      for (const [index, id] of contentIds.entries()) {
        try {
          const response = await DotCMSService.getContentById(id);
          if (response && typeof response === 'object') {
            results[index] = response as unknown as DotCMSPageContent;
          }
        } catch (error) {
          console.error(`Error fetching content for ID ${id}:`, error);
        }
      }
      return results;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 30 * 60 * 1000,   // 30 minutes
  });
}

export function usePrivacyPolicy() {
  return useDotCMSContent(useConfigStore().affiliateConfig.contents.DOTCMS_CONTENT_ID.PRIVACY_POLICY, 'privacy-policy');
}

export function useTermsAndConditions() {
  return useDotCMSContent(useConfigStore().affiliateConfig.contents.DOTCMS_CONTENT_ID.TERMS_AND_CONDITIONS, 'terms-conditions');
} 